export const PRIMARY_COLOR = '#faab03';
